import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import SettingGateway from '~apis/setting';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetSilverApiKeyHistoryListing(api: SettingGateway): SagaWatcherReturnType {
    yield takeEvery('setting/settingGetSilverAPIKeyHistoryListingAttempt', handleGetSilverApiKeyHistoryListing, api);
}

function* handleGetSilverApiKeyHistoryListing(api: SettingGateway) {
    const state = store.getState();

    const authToken = state.auth.userDetails.authToken;
    const { index } = state.setting.silverApiKeyHistoryListing;

    if (!authToken && authToken === undefined) {
        yield put(combinedActions.settingGetSilverAPIKeyHistoryListingFailure(ErrorMessages.GenericRequiredFieldNotProvided));
        return;
    }

    const response = yield* call([api, api.getSilverApiKeyHistoryListing], { authToken, index });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.settingGetSilverAPIKeyHistoryListingFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.settingGetSilverAPIKeyHistoryListingSuccess(response.data));
    }
}
